var map = {
	"./": 462,
	"./development": 1385,
	"./development.js": 1385,
	"./index": 462,
	"./index.js": 462,
	"./preprod": 1386,
	"./preprod.js": 1386,
	"./production": 1366,
	"./production.js": 1366,
	"./staging": 1387,
	"./staging.js": 1387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3360;